import { render, staticRenderFns } from "./merchantAccount.vue?vue&type=template&id=649de8f0&scoped=true"
import script from "./merchantAccount.vue?vue&type=script&lang=js"
export * from "./merchantAccount.vue?vue&type=script&lang=js"
import style0 from "./merchantAccount.vue?vue&type=style&index=0&id=649de8f0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "649de8f0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_manage_sbGx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('649de8f0')) {
      api.createRecord('649de8f0', component.options)
    } else {
      api.reload('649de8f0', component.options)
    }
    module.hot.accept("./merchantAccount.vue?vue&type=template&id=649de8f0&scoped=true", function () {
      api.rerender('649de8f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/merchantAccount/detail-pane/merchantAccount.vue"
export default component.exports